import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { MultipleChoices } from "../../../common/multiplechoices";
import { wantToAchiveStyles } from "./want-to-achive.styles";
import { wantToAchiveAnswerImages } from "./images";
import { getAssasmentsFocusAll } from "../../../initialAssessments/service";

const fetchFocusAll = async () => {
  const { data } = await getAssasmentsFocusAll();
  return data.data;
};

export const WantToAchive = ({ step }) => {
  const classes = wantToAchiveStyles();

  const { data } = useQuery({
    queryKey: ["focus"],
    queryFn: () => fetchFocusAll(),
    refetchOnWindowFocus: true,
  });

  const { onboarding } = useSelector((state) => ({
    onboarding: state.onboarding.onboarding,
  }));

  const renderImage = (image) => {
    const { alt, url } = wantToAchiveAnswerImages.get(image);

    return <img alt={alt} src={url} />;
  };

  const disabledCriteria = useCallback(
    (answer) => {
      const { focusId: id } = answer;
      return onboarding[step].answers.find(
        (answerItem) => Number(answerItem.id) === Number(id)
      );
    },
    [onboarding[step].answers]
  );

  return (
    <MultipleChoices
      answerClass={classes.answer}
      step={step}
      progress={0}
      answers={data || []}
      renderImage={renderImage}
      isSingleOption
      disabledCriteria={disabledCriteria}
    />
  );
};

WantToAchive.propTypes = {
  step: PropTypes.string.isRequired,
};
